import './apiBase'; // MOET als eerste: patcht window.fetch vóór App-code draait
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startSessie } from './sessieOpslag';

// Nieuwe sessie of voortzetting? Beslist vóór React de eerste pagina kiest: een
// nieuwe sessie begint op Market Prices, zonder filters en op de eerste subpagina.
startSessie();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA — service worker registreren. Enkel in productiebuilds, zodat de CRA
// dev-server (HMR) niet door SW-caching wordt gehinderd. Vereist HTTPS (of
// localhost); Render levert HTTPS. De SW cachet enkel de app-shell, nooit
// /api/-data (zie public/sw.js).
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Staat er al een nieuwe SW klaar (bv. geïnstalleerd via een andere tab)?
      if (reg.waiting && navigator.serviceWorker.controller) {
        window.dispatchEvent(new CustomEvent('sw-update-available', { detail: reg }));
      }
      // Nieuwe SW gevonden → wacht tot hij 'installed' is. Een bestaande controller
      // betekent dat dit een UPDATE is (niet de allereerste installatie).
      reg.addEventListener('updatefound', () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener('statechange', () => {
          if (sw.state === 'installed' && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent('sw-update-available', { detail: reg }));
          }
        });
      });
    }).catch(() => { /* stil falen */ });

    // Zodra de nieuwe SW de controle overneemt (na SKIP_WAITING), herlaad één keer
    // zodat de verse bundle actief wordt.
    let swReloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (swReloaded) return;
      swReloaded = true;
      window.location.reload();
    });
  });
}

// PWA: vang het install-prompt-event GLOBAAL op. Het kan al vóór login vuren,
// terwijl de in-app "Installeer app"-knop pas ná login (in het dashboard) mount.
// We bewaren het event op window zodat het dashboard het alsnog kan oppikken.
//
// Het event draagt een MOMENTOPNAME van het manifest dat op dat moment gold. Bij
// een eerste bezoek staat dat nog op het statische platform-manifest: het label
// van de gebruiker is dan nog nergens bekend (de bootstrap in index.html leest het
// pas vanaf het tweede bezoek uit localStorage). Wie op zo'n aanbod ingaat, zou het
// beeldmerk van het platform op zijn beginscherm krijgen — precies wat een
// partnerrol niet mag zien. Daarom stempelen we elk aanbod met het manifest waar
// het bij hoort; de manifest-effecten in App.jsx gooien een verouderd aanbod weg.
window.__installPrompt = null;
window.__manifestGebrand = window.__manifestGebrand || false;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  e.gebrand = !!window.__manifestGebrand;
  window.__installPrompt = e;
});
window.addEventListener('appinstalled', () => { window.__installPrompt = null; });

